import {Container} from "./Container"
import {Card} from "./Card"
import {Text} from "./Text"

export const NotificationsModalStyles = {
    Container: Container,
    Card: Card,
    Text: Text
}